export default {
  'app.console.nodata': '暫無資料',
  'app.console.recents': '近日訪問',
  'app.console.recents.nodata': '暫無資料，前去開通業務',
  'app.console.channel': '待開通服務',
  'app.console.channel.active': '已開通服務',
  'app.console.channel.activateService': '開通服務',
  'app.console.channel.learnMore': '瞭解詳情',
  'app.console.channel.sendNum': '傳送數量',
  'app.console.channel.targetNum': '有效目標',
  'app.console.channel.deliveredNum': '送達數量',
  'app.console.channel.clickNum': '點擊數量',
  'app.console.channel.readNum': '已讀數量',
  'app.console.channel.sendNumRate': '實發率',
  'app.console.channel.deliveredNumRate': '送達率',
  'app.console.channel.clickNumRate': '點擊率',
  'app.console.channel.readNumRate': '已讀率',
  'app.console.channel.title1': '近7日走勢',
  'app.console.channel.title2': '近7日轉化',
  'app.console.channel.sendOut': '傳送訊息',
  'app.console.channel.start': '開始使用',
  'app.console.channel.message.activated': '已啟動',
  'app.console.channel.message.apppush':
    '3分鐘快速集成SDK，實現智能化精准推送，有效提升用戶活躍度和留存率',
  'app.console.channel.message.email':
    '提供高效穩定的郵件發送 API，支持配置獨立 IP、BIMI 認證，並通過實時精準的數據回執，優化發送策略以提高送達率。',
  'app.console.channel.message.sms': '簡訊觸達能力覆蓋全球，幫助企業快速實現全球短信發送',
  'app.console.channel.message.whatsapp':
    '通過WhatsApp Business API，與超過20億的全球用戶建立更加緊密和自然的聯系',
  'app.console.channel.message.OTP':
    'EngageLab OTP 提供一次性密码的生成与校验服务，支持 WhatsApp、SMS、语音、电子邮件多通道发送，保证您的送达与转化。',
  'app.console.channel.message.webpush':
    '不再需要依賴移動APP，您可以隨時向網站訂閱者推送行銷消息和服務通知，提升用戶活躍和轉化',
  'app.console.channel.message.edm':
    ' 一鍵安裝無需開發，讓你的店鋪輕松開展電郵營銷，利用電郵自動化功能推動客戶參與購買，增加收入',
  'app.console.channel.message.ma':
    '行銷自動化服務支持管理用戶數據，構建用戶旅程，使用多渠道觸達您的用戶，為用戶提供響應迅速且個性化的體驗',
  'app.console.channel.message.captcha':
    '行為式驗證碼，更智能地解決機器腳本程序自動化攻擊帶來的業務損失與安全隱患。',
  'app.console.channel.message.livedesk': 'AI 驅動的客戶服務平台，完美處理 90% 的客戶問題。',
  'app.console.channel.flag.email': '新數據中心',
  'app.console.doc': 'REST API 檔案指南',
  'app.console.doc.apppush': 'AppPush 檔案指南',
  'app.console.doc.email': 'Email 檔案指南',
  'app.console.doc.sms': 'SMS 檔案指南',
  'app.console.doc.newsms': 'SMS 檔案指南',
  'app.console.doc.whatsapp': 'WhatsApp  檔案指南',
  'app.console.doc.webpush': 'WebPush  檔案指南',
  'app.console.doc.edm': 'EDM  檔案指南',
  'app.console.doc.otp': 'OTP 檔案指南',
  'app.console.doc.ma': 'Marketing Automation 檔案指南',
  'app.console.doc.captcha': 'CAPTCHA 檔案指南',
  'app.console.doc.livedesk': 'LiveDesk 檔案指南',
  'app.console.manage': '管理',
  'app.console.manage.orders': '訂單&帳單',
  'app.console.manage.pending': '待支付訂單',
  'app.console.manage.supplementary': '待補繳帳單',
  'app.console.manage.notification': '服務提醒',
  'app.console.manage.faq': '常見問題',
  'app.console.manage.download': '下載',
  'app.console.channel.verifiedRate': '回填率',
  'app.console.channel.verifiedNum': '回填數量',
  'app.console.channel.select.all': '全部',
};
